import React from "react";
import Countdown from "../Countdown";

const Body = () => {
  return (
    <>
      <Countdown />
    </>
  );
};

export default Body;
